<script setup lang="ts">
import { TuiInputNumber } from "@vm/tui";
import { useForm } from "@vm/vue-core";

import type { ComparisonSettings } from "../use-settings-editor-store";

const { formData } = useForm<ComparisonSettings>();
</script>

<template>
  <div class="space-y-4">
    <h2 class="text-lg font-medium text-gray-900">Layout</h2>
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <TuiInputNumber
        v-model="formData.layout.minColumnWidth"
        label="Minimum column width (px)"
        full-path="layout_minColumnWidth"
        :min="50"
        :max="600"
      />
      <TuiInputNumber
        v-model="formData.layout.fontSize"
        label="Tekstgrootte (px)"
        full-path="layout_fontSize"
        :min="6"
        :max="20"
      />
    </div>
  </div>
</template>
